import React, { useEffect, useRef, useState } from "react";
import SignedAudioPlayer from "./SignedAudioPlayer";
import { Box, Typography, Stack, Drawer, Collapse, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { classes } from "./MessageList";
import three_dots from "../../../assets/images/chats/three_dots.svg";
import starred_icon from "../../../assets/images/chats/starred_icon.svg";
import unstar_icon from "../../../assets/images/chats/unstar_icon.svg";
import replaym from "../../../assets/images/chats/reply.svg";
import PersonIcon from "../../../assets/images/chats/person.svg";
import FolderIcon from "../../../assets/images/chats/FolderIcon.svg";
import FileIcon from "../../../assets/images/chats/fileIcon.svg";
import pendingMsg_icon from "../../../assets/images/chats/pending_icon.svg";
import moment from "moment";
import MoreMenu from "./MoreMenu";
import TempMoreMenu from "./TempMoreMenu";
import ProgressBar from "./ProgressBar";
import InputDialogComponent from "../../../components/InputDialog";
import RecipientList from "./RecipientList";
import { getFileIconUrl, handleOpenFile, isGoogleYoutubeUrl } from "../../../utils/findextension";
import { AccountLevelArkchatPermission, ApprovalStatus, MessageType, TaskStatus, priorityValueColor, priorityValueLable } from "../../../utils/constant";
import session, { findGroupRecipientData, showUpdateTaskButton } from "../../../utils/helper";
import StartTask from "./StartTask";
import { useTranslation } from "react-i18next";
import HandleLink from "./HandleLink";
import {
  colorSchemes,
  personIconStyle,
} from "../../../assets/commonFunction";
import DividerView from "../../../common/DividerView/DividerView";
import TaskStatusButton from "../../../components/TaskStatusButton/TaskStatusButton";
import { useSelector } from "react-redux";
import {
  currentUserDataSelector,
  groupRecipientDetailsSelector,
  groupSubtopicDataSelector,
  groupTopicDataSelector,
  selectedGroupSelector,
} from "../../../customHooks/useAppSelectors";
import { handleMediaDownload, handleFetchMessages } from "../../../appStore/actions/ArkchatGroup/action";
import {
  handleAppSelectedTopic,
  handleAppSelectedTopicToSaveMsg,
  handleAppSelectedSubtopic,
  handleAppSelectedSubtopicToSaveMsg,
} from "../../../appStore/actions/AppState/action";
const GroupMessageView = ({
  item,
  isMoreMenuOpen,
  threeDotRef,
  isDeleteGroupMsgOpenIndicatorId,
  isDeleteGroupMsgOpen,
  handleReadStatusDrawer,
  handleShowUserProfile,
  setisTopicOpen,
  setMoveTopicMsgId,
  setMoveTopicTriggered,
  setDeleteGroupMsgOpenIndicatorId,
  setDeleteGroupMsgOpen,
  handlegetThreadMessages,
  setMoreMenu,
  menuRef,
  toggleItemMenu,
  handleStartTask,
  startTaskOpen,
  setStartTaskOpen,
  handleStarUnstarMsg,
  handleDeleteGrpMsg,
  setDeleteGrpMsgType,
  handleClickTaskUpdate,
  bgcolor,
  scrollToRepliedMessage,
  progress,
  dispatch,
  onPreviewFile,
  // A message of the viewer's not delivered yet (its pending copy): shown as
  // the same tile it will be once delivered, with the pending icon, so the
  // tile stays put and only loses the icon. Its actions wait for delivery;
  // its menu has Resend and Delete.
  pending = false,
  handleSendTempMsg,
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const [pendingMenuOpen, setPendingMenuOpen] = useState(false);
  const pendingMenuRef = useRef(null);
  const pendingDotsRef = useRef(null);
  useEffect(() => {
    if (!pendingMenuOpen) return undefined;
    const closeOnOutsideClick = (event) => {
      if (pendingMenuRef.current?.contains(event.target) || pendingDotsRef.current?.contains(event.target)) return;
      setPendingMenuOpen(false);
    };
    document.addEventListener("mousedown", closeOnOutsideClick);
    return () => document.removeEventListener("mousedown", closeOnOutsideClick);
  }, [pendingMenuOpen]);
  // Not delivered yet, it has no timetoken: it was sent at the time its
  // temp_timetoken ends with ("temp.<pnId>.<userId>.<µs>").
  const sentAt = pending
    ? Math.floor(Number(String(item?.temp_timetoken).split(".").pop()) / 1000) || Date.now()
    : Math.floor(item?.timetoken / 10000);
  const [isRecipientListOpen, setRecipientListOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [recipientList, setRecipientList] = useState([]);
  // Only the values used here (useAppSelectors() would re-render this on any
  // of ~45 store values changing).
  const selectedGroup = useSelector(selectedGroupSelector);
  const groupTopicData = useSelector(groupTopicDataSelector);
  const groupSubtopicData = useSelector(groupSubtopicDataSelector);
  const groupRecipientDetails = useSelector(groupRecipientDetailsSelector);
  const currentUserData = useSelector(currentUserDataSelector);
  // Only the parent thread's number and heading (the whole message list made
  // every message re-render whenever any message came in).
  const parentThreadNumber = useSelector((state) => (item?.thread_id
    ? state?.arkchatgroup?.messageList?.find((m) => m?.id === item?.thread_id)?.thread_number
    : undefined));
  const parentThreadHeading = useSelector((state) => (item?.thread_id
    ? state?.arkchatgroup?.messageList?.find((m) => m?.id === item?.thread_id)?.thread_heading
    : undefined));
  const isThreadScreen = session.get("isThreadScreen");
  const isSender = item?.from?.id === currentUserData?.id;

  const threadNumber = item?.thread_id ? parentThreadNumber : item?.thread_number;
  const threadHeading = item?.thread_id ? parentThreadHeading : item?.thread_heading;

  const handleSeeRecipientList = (recipientData) => {
    setRecipientList(recipientData);
    setRecipientListOpen(true);
  };

  const handleTopicBadgeClick = (topicObj, subtopicObj) => {
    if (!topicObj) return;
    dispatch(handleAppSelectedTopic(topicObj));
    dispatch(handleAppSelectedTopicToSaveMsg(topicObj));
    dispatch(handleAppSelectedSubtopic(subtopicObj || null));
    dispatch(handleAppSelectedSubtopicToSaveMsg(subtopicObj || null));
    dispatch(handleFetchMessages(selectedGroup?.pnId, topicObj?.id, { topicId: topicObj?.id }, null));
    setisTopicOpen(true);
  };

  return (
    <>
      <Drawer
        sx={{
          zIndex: 12011,
        }}
        anchor={"right"}
        open={isRecipientListOpen}
      >
        <RecipientList
          recipientList={recipientList}
          readby={item?.read_by}
          setRecipientListOpen={setRecipientListOpen}
          handleShowUserProfile={handleShowUserProfile}
          pnId={item?.pnId || item?.pn_id}
          tempTimetoken={item?.temp_timetoken}
          compact={item?.compact === true}
          senderId={item?.from?.id}
        />
      </Drawer>
      <Box
        width={"100%"}
        key={item?.temp_timetoken}
        px={"6px"}
        mb={"6px"}
        position="relative"
        sx={{ zIndex: (pending ? pendingMenuOpen : isMoreMenuOpen?.timetoken === item?.timetoken) ? 100 : "auto" }}
      >
        <Box
          width={"100%"}
          bgcolor={bgcolor === "transparent" ? "#FFFFFF" : bgcolor}
          borderRadius={"8px"}
          border={"1px solid #ECECEC"}
        >
          {(item?.type === 0 || item?.type === 1 || item?.type === 2) && (
            <>
              <Stack
                direction="row"
                width={"100%"}
                padding={"0.8rem"}
                justifyContent={"space-between"}
                id={`replied-message-${item?.temp_timetoken}`}
              >
                <div style={{ width: "100%" }}>
                  <Stack width={"100%"} direction="row" spacing={1}>
                    {/* ------------profile section--------------- */}
                    {findGroupRecipientData(
                      groupRecipientDetails,
                      item?.from?.id
                    )?.profileImgUrl ? (
                      <Box
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                      >
                        <img
                          src={
                            findGroupRecipientData(
                              groupRecipientDetails,
                              item?.from?.id
                            )?.profileImgUrl
                          }
                          alt="profile"
                          height="100%"
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        bgcolor={"#E3E1E1"}
                        width={"30px"}
                        height={"30px"}
                        display={"flex"}
                        flex={"none"}
                        alignItems={"center"}
                        flex-wrap={"wrap"}
                        justifyContent={"center"}
                        borderRadius={"0.15rem"}
                      // border={"1px solid blue"}
                      >
                        <img
                          style={personIconStyle}
                          src={PersonIcon}
                          alt="individual"
                        />

                        {/* <Typography variant="h6" fontSize={"0.75rem"}>
                          {item?.from?.name && item?.from?.name[0]}
                        </Typography> */}
                      </Box>
                    )}
                    {/* ------------Details section--------------- */}
                    <Box
                      width={"100%"}
                      paddingRight={2}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        containerType: "inline-size",
                        "@container (max-width: 555px)": {
                          "& .statusChipsInline": { display: "none" },
                        },
                      }}
                    >
                      <Stack
                        direction="row"
                        spacing={1}
                        width={"100%"}
                        justifyContent={"space-between"}
                      >
                        <Box
                          direction="row"
                          display={"flex"}
                          spacing={1}
                          alignItems={"center"}
                        >
                          <Typography variant="subtitle2" fontWeight={"450"}>
                            {item?.from?.name}
                          </Typography>
                          <Typography
                            sx={{ ...classes.duetime, marginLeft: "0.5rem" }}
                          >
                            {/* Time */}
                            {moment(sentAt).format(
                              currentUserData?.userDateTimeFormat
                            )}
                          </Typography>
                          {pending && (
                            <Box sx={{ ...classes.tick, marginLeft: "0.5rem", marginTop: -2.2 }}>
                              <img src={pendingMsg_icon} alt="Chat Status" />
                            </Box>
                          )}
                        </Box>
                        {/* ------------Right section--------------- */}
                        <Box
                        // border={"1px solid"}
                        >
                          <Stack
                            // border={"1px solid"}
                            spacing={2}
                            direction="row"
                            alignItems={"center"}
                          >
                            <Box position={"relative"}>
                              <Box
                                ref={pending ? pendingDotsRef : threeDotRef}
                                onClick={() => (pending ? setPendingMenuOpen((open) => !open) : toggleItemMenu(item))}
                                sx={{
                                  cursor: "pointer",
                                  pointerEvents: !pending && isMoreMenuOpen ? "none" : "",
                                }}
                              >
                                <img src={three_dots} alt="more" />
                              </Box>
                              {pending && pendingMenuOpen && (
                                <TempMoreMenu
                                  handleSendTempMsg={handleSendTempMsg}
                                  menuRef={pendingMenuRef}
                                  messageData={item}
                                  setMoreMenu={() => setPendingMenuOpen(false)}
                                />
                              )}
                              {!pending && isMoreMenuOpen?.timetoken ===
                                item?.timetoken && (
                                  <MoreMenu
                                    selectedGroup={selectedGroup}
                                    isThreadScreen={isThreadScreen}
                                    menuRef={menuRef}
                                    messageData={item}
                                    setMoreMenu={setMoreMenu}
                                    isStarred={item?.isStarred}
                                    handleReplyMessage={handlegetThreadMessages}
                                    setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                                    setDeleteGroupMsgOpenIndicatorId={
                                      setDeleteGroupMsgOpenIndicatorId
                                    }
                                    setMoveTopicTriggered={setMoveTopicTriggered}
                                    setMoveTopicMsgId={setMoveTopicMsgId}
                                    setisTopicOpen={setisTopicOpen}
                                    handleReadStatusDrawer={
                                      handleReadStatusDrawer
                                    }
                                  />
                                )}
                              <>
                                {!pending && isDeleteGroupMsgOpen &&
                                  isDeleteGroupMsgOpenIndicatorId ===
                                  item?.timetoken && (
                                    <>
                                      <InputDialogComponent
                                        title="Delete"
                                        isType="deletegroupmessage"
                                        open={isDeleteGroupMsgOpen}
                                        handleClose={() => {
                                          setDeleteGroupMsgOpen(false);
                                          setDeleteGroupMsgOpenIndicatorId(
                                            null
                                          );
                                        }}
                                        btnLabel="Delete"
                                        setDeleteGrpMsgType={
                                          setDeleteGrpMsgType
                                        }
                                        onClick={() => handleDeleteGrpMsg(item)}
                                        isallowedDeleteGrpMsgForall={
                                          (currentUserData?.id ===
                                            item?.from?.id ||
                                            currentUserData?.activePermission ===
                                            AccountLevelArkchatPermission?.ADMIN) &&
                                            moment().diff(
                                              Math.floor(item?.timetoken / 10000),
                                              "minutes"
                                            ) <= 30
                                            ? false
                                            : true
                                        }
                                      />
                                    </>
                                  )}
                              </>
                            </Box>

                            <Box
                              onClick={() =>
                                !pending &&
                                handleStarUnstarMsg(
                                  item?.timetoken,
                                  item?.starred_by
                                )
                              }
                              sx={{
                                cursor: pending ? "default" : "pointer",
                                width: "16px",
                              }}
                            >
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={
                                  item?.starred_by?.includes(currentUserData?.id)
                                    ? starred_icon
                                    : unstar_icon
                                }
                                alt="more"
                              />
                            </Box>
                          </Stack>
                        </Box>
                        {/* ------------------------------------------ */}
                      </Stack>
                      <Typography
                        onClick={() => !pending && handleSeeRecipientList(item?.to)}
                        variant="subtitle2"
                        display={"inline-block"}
                        sx={classes.userlink}
                      >
                        {item?.is_all_group_member
                          ? "To all group members"
                          : `To ${item?.to[0]?.name}${(item?.recipient_count ?? item?.to?.length) > 1
                            ? `, and ${(item?.recipient_count ?? item?.to?.length) - 1} more`
                            : ""
                          }`}
                      </Typography>

                      {/* -------------reply---------- */}
                      {item?.thread_original_message &&
                        item?.thread_original_message?.translations && (
                          <Stack
                            direction="row"
                            spacing={1}
                            width={"100%"}
                            sx={{
                              ...classes.chatRep,
                              cursor: "pointer",
                              wordWrap: "break-word",
                            }}
                            onClick={() =>
                              scrollToRepliedMessage(
                                item?.thread_original_message?.temp_timetoken
                              )
                            }
                          >
                            <img
                              src={replaym}
                              alt="reply"
                              style={{
                                width: "18px",
                                height: "12px",
                                flexShrink: 0,
                                alignSelf: "center",
                              }}
                            />
                            {item?.thread_original_message?.translations[
                              item?.to?.find(
                                (data) =>
                                  data?.id === currentUserData?.id
                              )?.languageCode
                            ] ? (
                              <Typography
                                width={"95%"}
                                variant="body2"
                                sx={{ wordWrap: "break-word" }}
                              >
                                {(isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                  item?.thread_original_message?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]?.slice(0, 200) + " ..."}
                              </Typography>
                            ) : (
                              <Typography
                                width={"95%"}
                                variant="body2"
                                sx={{ wordWrap: "break-word" }}
                              >
                                {(isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                  item?.thread_original_message?.message?.slice(
                                    0,
                                    200
                                  ) + " ..."}
                              </Typography>
                            )}
                          </Stack>
                        )}

                      {/* text message */}
                      <Box width={"100%"}>
                        <HandleLink>
                          {item?.translations &&
                            item?.translations[
                            item?.to?.find(
                              (data) =>
                                data?.id === currentUserData?.id
                            )?.languageCode
                            ] ? (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                (isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                item?.translations[
                                  item?.to?.find(
                                    (data) =>
                                      data?.id ===
                                      currentUserData?.id
                                  )?.languageCode
                                ]
                                  ?.slice(0, 200)
                                  ?.split(/\n/)
                                  ?.map((line, indx) => (
                                    <span
                                      key={line + indx + "xyz007"}
                                      style={{
                                        marginBottom: "0.5rem",
                                        display: "block",
                                        border:
                                          line === ""
                                            ? "1px solid transparent"
                                            : "none",
                                      }}
                                    >
                                      <>{line === "" ? " " : line}</>
                                    </span>
                                  ))}{" "}
                              {!expanded &&
                                item?.translations[
                                  item?.to?.find(
                                    (data) =>
                                      data?.id === currentUserData?.id
                                  )?.languageCode
                                ]?.length > 200
                                ? " ..."
                                : ""}
                              <Collapse
                                sx={{ wordWrap: "break-word" }}
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {(isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                  item?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]
                                    ?.split(/\n/)
                                    ?.map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz008"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        <>{line === "" ? " " : line}</>
                                      </span>
                                    ))}
                              </Collapse>
                              {item?.translations[
                                item?.to?.find(
                                  (data) =>
                                    data?.id === currentUserData?.id
                                )?.languageCode
                              ]?.length > 200 && (
                                  <Typography
                                    width={"100%"}
                                    variant="body2"
                                    expand={expanded}
                                    onClick={() => setExpanded(!expanded)}
                                    aria-expanded={expanded}
                                    aria-label="show more"
                                    sx={{
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                    display={"inline"}
                                    color={"#2C86FF"}
                                  >
                                    {expanded ? "less" : "more"}
                                  </Typography>
                                )}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                (isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                item?.message?.slice(0, 200) +
                                (item?.message?.length > 200 ? " ..." : "")}
                              <Collapse
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {(isSender || item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1) &&
                                  item?.message
                                    ?.split(/\n/)
                                    .map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz009"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        {line}
                                      </span>
                                    ))}
                              </Collapse>

                              {item?.message?.length > 200 && (
                                <Typography
                                  width={"100%"}
                                  variant="body2"
                                  expand={expanded}
                                  onClick={() => setExpanded(!expanded)}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                  sx={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  display={"inline"}
                                  color={"#2C86FF"}
                                >
                                  {expanded ? "less" : "more"}
                                </Typography>
                              )}
                            </Typography>
                          )}
                        </HandleLink>
                      </Box>

                      {/* -----------------Topic + Thread row------------------ */}
                      {(() => {
                        const subtopic = item?.subtopic_id ? (groupSubtopicData || []).find((d) => d?.id === item?.subtopic_id) : null;
                        const resolvedTopicId = item?.topic_id || subtopic?.topicId || subtopic?.topic_id || "";
                        const topicObj = groupTopicData?.data?.find((d) => d?.id === resolvedTopicId) || null;
                        const topicName = topicObj?.name || "";
                        const subtopicName = subtopic?.name || "";
                        const label = subtopicName ? `${topicName} > ${subtopicName}` : topicName;
                        return (
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            mt="auto"
                            pt="0.5rem"
                          >
                            {label ? (
                              <Box
                                display="flex"
                                gap="0.3rem"
                                alignItems="center"
                                flexWrap="nowrap"
                                sx={{ cursor: topicObj ? "pointer" : "default", overflow: "hidden", flexShrink: 1, minWidth: 0 }}
                                onClick={() => topicObj && handleTopicBadgeClick(topicObj, subtopic)}
                              >
                                <img src={FileIcon} alt="topic" style={{ width: "14px", height: "14px", flexShrink: 0 }} />
                                <Typography
                                  title={label}
                                  sx={{
                                    ...classes.userlink2,
                                    maxWidth: "160px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {label}
                                </Typography>
                              </Box>
                            ) : (
                              <Box />
                            )}
                            <Box
                              onClick={() => !pending && handlegetThreadMessages(item, false)}
                              sx={{
                                border: "1px solid #DBDBDB",
                                borderRadius: "4px",
                                px: "0.5rem",
                                py: "0.15rem",
                                cursor: pending ? "default" : "pointer",
                                display: "flex",
                                alignItems: "center",
                                flexShrink: 0,
                                minWidth: "80px",
                                maxWidth: "220px",
                              }}
                            >
                              <Typography
                                fontSize="0.75rem"
                                color="#000"
                                sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                              >
                                {threadHeading
                                  ? `# ${threadNumber} - ${threadHeading}`
                                  : `# Thread ${threadNumber ?? ""}`}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      })()}

                      {/* -----------------subUser details------------------ */}
                      {item?.type !== 0 && item?.type !== 3 && (
                        <>
                          <Box
                            sx={{
                              borderTop: "1px solid #F0F0F0",
                              mt: "0.8rem",
                              ml: "calc(-30px - 8px)",
                              mr: "-16px",
                            }}
                          />
                          <Stack
                            mt={"0.5rem"}
                            direction="row"
                            spacing={1}
                            gap={"2.5rem"}
                            width={"100%"}
                            justifyContent={"space-between"}
                            alignItems={"center"}

                          >
                            <Stack direction="row" spacing={1} alignItems={"center"}>
                              {item?.assignee?.pp ? (
                                <Box
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                  sx={{
                                    ...classes.chatUserprofile,
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={item?.assignee?.pp}
                                    alt="profile"
                                    height="100%"
                                  />
                                </Box>
                              ) : (
                                <Box
                                  sx={{ cursor: "pointer" }}
                                  bgcolor={"#E3E1E1"}
                                  width={"27px"}
                                  height={"27px"}
                                  display={"flex"}
                                  flex={"none"}
                                  alignItems={"center"}
                                  flex-wrap={"wrap"}
                                  justifyContent={"center"}
                                  borderRadius={"0.15rem"}
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                >
                                  <img
                                    style={personIconStyle}
                                    src={PersonIcon}
                                    alt="individual"
                                  />
                                  {/* <Typography variant="h6" fontSize={"0.75rem"}>
                                    {item?.assignee?.name &&
                                      item?.assignee?.name[0]}
                                  </Typography> */}
                                </Box>
                              )}
                              <Box>
                                <Box sx={{ ...classes.userInfo, marginTop: "0 !important" }}>
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    flexDirection={"row"}
                                    alignItems={"center"}
                                    flexWrap={"wrap"}
                                    rowGap={"0.25rem"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight={"400"}
                                      fontSize={"0.75rem"}
                                    >
                                      {item?.type === MessageType?.Approval
                                        ? "Approval requested to"
                                        : item?.is_main ? "Task assigned to" : "Subtask assigned to"}{" "}
                                      {item?.assignee?.name}
                                    </Typography>
                                    <Box
                                      className="statusChipsInline"
                                      display={"flex"}
                                      gap={"0.5rem"}
                                      alignItems={"center"}
                                    >
                                      <TaskStatusButton
                                        item={item}
                                        status="approval"
                                      />
                                      {/*Pending Button */}
                                      <TaskStatusButton
                                        item={item}
                                        status="task"
                                      />
                                    </Box>
                                  </Stack>
                                </Box>
                              </Box>
                            </Stack>

                            <Stack direction="row" spacing={1} sx={{ pointerEvents: pending ? "none" : undefined }}>
                              {item?.type === MessageType?.Approval && (
                                <>
                                  {(item?.from?.id ===
                                    currentUserData?.id ||
                                    item?.assignee?.id ===
                                    currentUserData?.id) &&
                                    item?.approval_status !==
                                    ApprovalStatus?.Approved &&
                                    item?.approval_status !==
                                    ApprovalStatus?.Rejected &&
                                    item?.approval_status !==
                                    ApprovalStatus?.Cancelled && (
                                      <Stack
                                        direction="row"
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #000000",
                                        }}
                                        color={"#fff"}
                                        bgcolor={"#fff"}
                                        onClick={() =>
                                          handleClickTaskUpdate(item)
                                        }
                                      >
                                        <Typography
                                          sx={{
                                            ...classes.txt,
                                            color: colorSchemes.black,
                                          }}
                                        >
                                          {" "}
                                          Update{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                </>
                              )}
                              {item?.type === MessageType?.Task && (
                                <>
                                  {(item?.assignee?.id ===
                                    currentUserData?.id) &&
                                    (item?.task_status ===
                                      TaskStatus?.Pending ||
                                      item?.task_status ===
                                      TaskStatus?.Delayed) && (
                                      <Stack
                                        direction="row"
                                        position={"relative"}
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          border: "1px solid #000000",
                                          alignItems: "center",
                                        }}
                                        color={"#fff"}
                                        // bgcolor={"#DB0011"}
                                        onClick={() => handleStartTask(item)}
                                      >
                                        {startTaskOpen?.timetoken ===
                                          item?.timetoken && (
                                            <StartTask
                                              open={
                                                startTaskOpen?.timetoken ===
                                                item?.timetoken
                                              }
                                              taskData={item}
                                              setStartTaskOpen={setStartTaskOpen}
                                            />
                                          )}
                                        {/* <Box
                                          display={"flex"}
                                          alignItems={"center"}
                                        >
                                          <TaskSvg
                                            circleColor={colorSchemes.themeRedColor}
                                            tickColor={colorSchemes.themeRedColor}
                                          />
                                        </Box> */}
                                        <Typography sx={{ ...classes.txt }}>
                                          {" "}
                                          Start{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                  {showUpdateTaskButton(currentUserData, item, groupRecipientDetails)
                                    && (
                                      <Stack
                                        direction="row"
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          border: "1px solid #000000",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                        color={"#fff"}
                                        bgcolor={"#fff"}
                                        onClick={() =>
                                          handleClickTaskUpdate(item)
                                        }
                                      >
                                        <Typography
                                          sx={{
                                            ...classes.txt,
                                            color: colorSchemes.black,
                                          }}
                                        >
                                          {" "}
                                          Update{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                </>
                              )}
                            </Stack>
                          </Stack>

                          {(() => {
                            const assignedLabel =
                              item?.type === MessageType?.Approval
                                ? appContent?.KEY343
                                : appContent?.KEY342;
                            const assignedDate = moment(sentAt).format(
                              currentUserData?.userDateFormat
                            );
                            const dueDate = moment(item?.due_date).format(
                              currentUserData?.userDateFormat
                            );
                            const dueTime = moment(
                              item?.due_time,
                              "HH:mm"
                            ).format(currentUserData?.userTimeFormat);
                            const priorityWord =
                              item?.type === MessageType?.Task
                                ? "Task"
                                : "Approval";
                            const startedDate =
                              item?.start_time > 0
                                ? moment
                                  .unix(item?.start_time)
                                  .format(currentUserData?.userDateFormat)
                                : null;
                            const finishedDate =
                              item?.end_time > 0
                                ? moment
                                  .unix(item?.end_time)
                                  .format(currentUserData?.userDateFormat)
                                : null;
                            const estimatedTime = item?.estimated_time
                              ?.timeValue
                              ? `${item?.estimated_time?.timeValue} ${item?.estimated_time?.timeType}`
                              : null;
                            const actualTime = item?.actual_time?.timeValue
                              ? `${item?.actual_time?.timeValue} ${item?.actual_time?.timeType}`
                              : null;
                            const showCompletion = Boolean(
                              estimatedTime && item?.end_time > 0
                            );
                            const isOnTime =
                              item?.actual_time?.timeValue <
                              item?.estimated_time?.timeValue ||
                              Math.abs(item?.diff_time?.timeValue) === 0;
                            const completionColor = isOnTime
                              ? "#007F8F"
                              : "#DB0011";
                            const completionLong =
                              Math.abs(item?.diff_time?.timeValue) > 0
                                ? `${Math.abs(item?.diff_time?.timeValue)} ${item?.diff_time?.timeType
                                } ${item?.actual_time?.timeValue <
                                  item?.estimated_time?.timeValue
                                  ? "Less"
                                  : "More"
                                }`
                                : appContent?.KEY270;
                            const completionShort =
                              Math.abs(item?.diff_time?.timeValue) > 0
                                ? completionLong
                                : "Completed on time";
                            const prioritySquare = (
                              <span
                                style={{
                                  display: "inline-block",
                                  width: "13px",
                                  height: "13px",
                                  verticalAlign: "middle",
                                  margin: "-1px 5px 0px 5px",
                                  backgroundColor:
                                    priorityValueColor[item?.priority],
                                }}
                              ></span>
                            );
                            return (
                              <Box
                                ml={"2.18rem"}
                                sx={{
                                  "& .taskDetailsNarrow": { display: "none" },
                                  "@container (max-width: 555px)": {
                                    "& .taskDetailsWide": { display: "none" },
                                    "& .taskDetailsNarrow": {
                                      display: "flex",
                                    },
                                  },
                                }}
                              >
                                {/* wide: one/no side panel open — 3-column grid */}
                                <Box
                                  className="taskDetailsWide"
                                  sx={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "repeat(3, max-content)",
                                    columnGap: "2.5rem",
                                    rowGap: "0.35rem",
                                    alignItems: "center",
                                  }}
                                >
                                  <Typography fontSize={"0.75rem"}>
                                    {assignedLabel} : {assignedDate}
                                  </Typography>
                                  <Typography fontSize={"0.75rem"}>
                                    Due on : {dueDate} {dueTime}
                                  </Typography>
                                  <Typography fontSize={"0.75rem"}>
                                    {priorityWord} Priority :{prioritySquare}
                                    {priorityValueLable[item?.priority]}
                                  </Typography>
                                  {startedDate && (
                                    <Typography fontSize={"0.75rem"}>
                                      Started : {startedDate}
                                    </Typography>
                                  )}
                                  {estimatedTime && (
                                    <Typography fontSize={"0.75rem"}>
                                      Estimated time : {estimatedTime}
                                    </Typography>
                                  )}
                                  {actualTime && (
                                    <Typography fontSize={"0.75rem"}>
                                      Actual Time : {actualTime}
                                    </Typography>
                                  )}
                                  {finishedDate && (
                                    <Typography fontSize={"0.75rem"}>
                                      Finished : {finishedDate}
                                    </Typography>
                                  )}
                                  {showCompletion && (
                                    <Typography
                                      fontSize={"0.75rem"}
                                      color={completionColor}
                                      sx={{ gridColumn: "span 2" }}
                                    >
                                      {completionLong}
                                    </Typography>
                                  )}
                                </Box>
                                {/* narrow: both side panels open — stacked pairs */}
                                <Box
                                  className="taskDetailsNarrow"
                                  sx={{
                                    flexDirection: "column",
                                    rowGap: "0.35rem",
                                  }}
                                >
                                  <Box
                                    display={"flex"}
                                    gap={"0.5rem"}
                                    alignItems={"center"}
                                  >
                                    <TaskStatusButton
                                      item={item}
                                      status="approval"
                                    />
                                    {/*Pending Button */}
                                    <TaskStatusButton
                                      item={item}
                                      status="task"
                                    />
                                  </Box>
                                  <Box
                                    display={"flex"}
                                    gap={"0.4rem"}
                                    alignItems={"center"}
                                    flexWrap={"wrap"}
                                  >
                                    <Typography fontSize={"0.75rem"}>
                                      {assignedLabel} : {assignedDate}
                                    </Typography>
                                    <DividerView />
                                    <Typography fontSize={"0.75rem"}>
                                      Due : {dueDate}, {dueTime}
                                    </Typography>
                                  </Box>
                                  <Box
                                    display={"flex"}
                                    gap={"0.4rem"}
                                    alignItems={"center"}
                                    flexWrap={"wrap"}
                                  >
                                    <Typography fontSize={"0.75rem"}>
                                      Priority :{prioritySquare}
                                      {priorityValueLable[item?.priority]}
                                    </Typography>
                                    {startedDate && (
                                      <>
                                        <DividerView />
                                        <Typography fontSize={"0.75rem"}>
                                          Started : {startedDate}
                                        </Typography>
                                      </>
                                    )}
                                  </Box>
                                  {estimatedTime && (
                                    <Box
                                      display={"flex"}
                                      gap={"0.4rem"}
                                      alignItems={"center"}
                                      flexWrap={"wrap"}
                                    >
                                      <Typography fontSize={"0.75rem"}>
                                        Estimated time : {estimatedTime}
                                      </Typography>
                                      {actualTime && (
                                        <>
                                          <DividerView />
                                          <Typography fontSize={"0.75rem"}>
                                            Actual Time : {actualTime}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                  )}
                                  {finishedDate && (
                                    <Box
                                      display={"flex"}
                                      gap={"0.4rem"}
                                      alignItems={"center"}
                                      flexWrap={"wrap"}
                                    >
                                      <Typography fontSize={"0.75rem"}>
                                        Finished : {finishedDate}
                                      </Typography>
                                      {showCompletion && (
                                        <>
                                          <DividerView />
                                          <Typography
                                            fontSize={"0.75rem"}
                                            color={completionColor}
                                          >
                                            {completionShort}
                                          </Typography>
                                        </>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            );
                          })()}
                        </>
                      )}
                      {/* -----------------Attachments------------------ */}
                      <>
                        {/* Pending: the files being uploaded. */}
                        {pending && item?.fileData?.length > 0 && (
                          <Box mt={"0.5rem"}>
                            {item?.fileData?.map((fileData) => (
                              <Box key={fileData?.id ?? fileData?.name} display={"flex"} alignItems={"center"} gap={"0.2rem"}>
                                <img style={{ height: "25px", width: "25px" }} src={getFileIconUrl(fileData?.name)} alt={fileData?.name} />
                                <Typography variant="subtitle2" fontWeight={"400"} fontSize={"0.75rem"}>
                                  {fileData?.name}
                                </Typography>
                              </Box>
                            ))}
                            {progress > 0 && <ProgressBar value={progress} />}
                          </Box>
                        )}
                        {item?.attachments?.length > 0 && (
                          <Box mt={"0.5rem"}>
                            {item?.attachments.map((fileData) => {
                              const fileIconOrType = getFileIconUrl(
                                fileData?.location
                              );
                              const isAudio = fileIconOrType === "audio";
                              return (
                                <Box key={fileData?.location} mt={"0.5rem"}>
                                  {isAudio ? (
                                    <SignedAudioPlayer location={fileData?.location} />
                                  ) : (
                                    <Box
                                      sx={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (isGoogleYoutubeUrl(fileData?.location)) {
                                          window.open(fileData?.location, "_blank");
                                        } else {
                                          handleOpenFile(dispatch, fileData, handleMediaDownload);
                                        }
                                      }}>
                                      <Box display={"flex"} alignItems={"center"} gap={"0.2rem"}>
                                        <img style={{ height: "25px", width: "25px" }} src={fileIconOrType} alt={fileData?.name} />
                                        <Typography variant="subtitle2" fontWeight={"400"} fontSize={"0.75rem"}>
                                          {fileData?.name}
                                        </Typography>
                                        {onPreviewFile && (
                                          <IconButton
                                            size="small"
                                            title="Preview"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              onPreviewFile(fileData);
                                            }}
                                            sx={{ padding: "2px" }}
                                          >
                                            <VisibilityOutlinedIcon sx={{ fontSize: "1rem" }} />
                                          </IconButton>
                                        )}
                                      </Box>
                                    </Box>
                                  )}
                                </Box>
                              );
                            })}
                          </Box>
                        )}
                      </>

                    </Box>
                  </Stack>
                </div>
              </Stack>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

// Re-rendered only when its own props change (MessageList passes handlers
// with a fixed identity), not for every message that comes in.
export default React.memo(GroupMessageView);
